var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coach)?_c('div',[_c('router-link',{class:_vm.cssClass,attrs:{"to":'/users/' + _vm.coach.id}},[_vm._v(" "+_vm._s(_vm.coach.coach.name)+" ")]),(_vm.coach)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.goToUser}},[_c('i',{staticClass:"icon-user"})]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }